module.exports = __webpack_public_path__ + "static/img/developbanner.32a0aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/developbanner.png
// module id = uNof
// module chunks = 0